// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Message_Stroke1_Corner0_Rounded_Filled = createSinglePathSVG({
  path: 'M21.75 12a9.75 9.75 0 0 1-14.332 8.608l-3.193 1.064a1.5 1.5 0 0 1-1.897-1.897l1.064-3.192A9.75 9.75 0 1 1 21.75 12Z',
  viewBox: '0 0 24 24',
  glyph: 'Message_Stroke1_Corner0_Rounded_Filled',
})

export const Message_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M12 2.25a9.75 9.75 0 0 0-8.608 14.333l-1.064 3.192a1.5 1.5 0 0 0 1.897 1.897l3.192-1.064A9.75 9.75 0 1 0 12 2.25Zm0 18a8.24 8.24 0 0 1-4.13-1.107.75.75 0 0 0-.614-.063L3.75 20.25l1.17-3.506a.75.75 0 0 0-.063-.613A8.25 8.25 0 1 1 12 20.25Z',
  viewBox: '0 0 24 24',
  glyph: 'Message_Stroke2_Corner0_Rounded',
})

export const Message_Stroke2_Corner0_Rounded_Filled = createSinglePathSVG({
  path: 'M21.75 12a9.75 9.75 0 0 1-14.332 8.608l-3.193 1.064a1.5 1.5 0 0 1-1.897-1.897l1.064-3.192A9.75 9.75 0 1 1 21.75 12Z',
  viewBox: '0 0 24 24',
  glyph: 'Message_Stroke2_Corner0_Rounded_Filled',
})

export const MessagePlus_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M13.125 12A1.125 1.125 0 1 1 12 10.875 1.125 1.125 0 0 1 13.125 12Zm-5.25-1.125A1.125 1.125 0 1 0 9 12a1.125 1.125 0 0 0-1.125-1.125Zm8.25 0A1.125 1.125 0 1 0 17.25 12a1.125 1.125 0 0 0-1.125-1.125ZM21.75 12a9.75 9.75 0 0 1-14.332 8.608l-3.193 1.064a1.5 1.5 0 0 1-1.897-1.897l1.064-3.192A9.75 9.75 0 1 1 21.75 12Zm-1.5 0a8.25 8.25 0 1 0-15.393 4.13.75.75 0 0 1 .062.614L3.75 20.25l3.506-1.17a.7.7 0 0 1 .237-.038.75.75 0 0 1 .375.1A8.25 8.25 0 0 0 20.25 12Z',
  viewBox: '0 0 24 24',
  glyph: 'MessagePlus_Stroke2_Corner0_Rounded',
})
